import { styled } from "@material-ui/core";
import { div } from "lqx-react/lib";
import React from "react";
import { DigiSelect } from "../../../components/select";

export const GlobalFieldSelectionSection = ({ $mapTo }
  : { $mapTo: any }) => {
  const GlobalFieldFromOptions = [
    { id: 1, name: "Below" },
    { id: 2, name: "Above" },
    { id: 3, name: "Left" },
    { id: 4, name: "Right" }
  ];
  return (
    <>
      <GlobalFieldSelection title=''>
        <Label>Select Global Field Value From Cell</Label>
        <GlobalFieldLocationSelect lqx-qa-id="GlobalFieldLocationFields" id="id" label="name"
          $value={$mapTo} options={GlobalFieldFromOptions}></GlobalFieldLocationSelect>
      </GlobalFieldSelection>
    </>
  );
};

const Label = div({
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '13px',
  padding: '4px',
  marginTop: '5px',
  color: '#4197d6'
});

const GlobalFieldLocationSelect = styled(DigiSelect)({
  width: '250px',
  borderRadius: '4px',
  '& .MuiSelect-root': {
    borderRadius: '4px',
  },
  '& .MuiSelect-icon': {
    top: 'calc(50% - 9px)'
  },
});

const GlobalFieldSelection = div({
  '& .MuiDialog-paperFullWidth': {
    width: '350px',
  }
});